import { mapGetters } from 'vuex'
import { getStrategyTags } from '@/api/strategies'
import RedundantRouteMixin from '@/components/RedundantRouteMixin.js'
import { noSelMixin } from '@/contentprofile/no_sel_mixins'
export {
  filterProps,
  gradeOptions,
  isParamBeta,
  strategyFiltersDataMixin,
  strategyFiltersPropsMixinFactory,
  emptyTextOptions
}

const betaParams = []
function isParamBeta(param) {
  return betaParams.indexOf(param) > -1
}

const filterProps = {
  subject: {
    type: String,
    default: ''
  },
  barrier: {
    type: String,
    default: ''
  },
  grades: {
    type: Array,
    default: null
  },
  setting: {
    type: String,
    default: ''
  },
  teachingType: {
    type: String,
    default: ''
  },
  query: {
    type: String,
    default: ''
  }
}

const gradeOptions = [
  { label: 'Pre-K', value: ['Pre-K'] },
  { label: 'K-2', value: ['K', '1', '2'] },
  { label: '3-5', value: ['3', '4', '5'] },
  { label: '6-8', value: ['6', '7', '8'] },
  { label: '9-12', value: ['9', '10', '11', '12'] }
]

const emptyTextOptions = {
  subject: '(all subjects)',
  barrier: subject => `(all barriers for ${subject})`,
  grades: '(all grades)',
  setting: '(all settings)',
  teachingType: '(all types)'
}

const strategyFiltersDataMixin = {
  data() {
    return {
      loadingOptions: false,
      subjectOptions: [],
      subjectBarriersMap: {},
      teachingTypeOptions: [],
      settingOptions: [],
      gradeOptions
    }
  },
  mixins: [noSelMixin],
  computed: {
    ...mapGetters('visibility', ['betaVisibility']),
    barrierOptions() {
      return this.subjectBarriersMap[this.subject]
    },
    gradeLabel() {
      if (this.grades) {
        let selectedGradeObj = this.gradeOptions.filter(
          gradeObj => gradeObj.value.join() === this.grades.join()
        )
        if (selectedGradeObj.length === 1) {
          return selectedGradeObj[0].label
        }
      }
      return ''
    }
  },
  watch: {
    betaVisibility() {
      this.getStrategyTagsAndParseIntoOptions()
    }
  },
  methods: {
    async getStrategyTagsAndParseIntoOptions() {
      this.loadingOptions = true

      let params = { published: 1 }
      if (this.betaVisibility) {
        params = {}
      }
      let tags = await getStrategyTags(params)
      this.loadingOptions = false
      this.subjectOptions = tags.subjects.map(subject => {
        return {value: subject, label: this.getStrategySubjectLabelFromValue(subject)}
      })
      this.teachingTypeOptions = tags.teaching_types
      this.settingOptions = tags.instructional_settings
      this.subjectBarriersMap = {}

      this.subjectOptions.forEach(subject => {
        this.subjectBarriersMap[subject.value] = tags[subject.value]
      })
    },
    shouldShowParam(param) {
      return (isParamBeta(param) && this.betaVisibility) || !isParamBeta(param)
    }
  },
  async created() {
    this.getStrategyTagsAndParseIntoOptions()
  }
}

function strategyFiltersPropsMixinFactory({ routeName }) {
  return {
    props: filterProps,
    mixins: [RedundantRouteMixin],
    computed: {
      urlQuery() {
        return {
          subject: this.subject || undefined,
          barrier: this.barrier || undefined,
          grades: (this.grades && this.grades.join(',')) || undefined,
          setting: this.setting || undefined,
          teachingType: this.teachingType || undefined,
          query: this.query || undefined
        }
      },
      subjectIsOther() {
        return this.subject === 'Other'
      },
      disableSubmitButton() {
        return this.subjectIsOther && !this.barrier
      }
    },
    methods: {
      updateRouteQuery({ field, value }) {
        let update = {}
        update[field] = value

        if (field === 'subject') {
          update.barrier = undefined
        }

        if (field === 'grades' && value) {
          update[field] = value.join(',')
        }

        this.rerouteIfRouteChanged(this.$route, {
          query: Object.assign({}, this.urlQuery, update),
          name: routeName
        })
      },
      sendFiltersEvent(evtName) {
        let evtData = {
          subject: this.subject || undefined,
          barrier: this.barrier || undefined,
          grades: this.grades || undefined,
          setting: this.setting || undefined,
          teachingType: this.teachingType || undefined,
          query: this.query || undefined
        }
        this.$sendEvent(evtName, evtData)
      }
    }
  }
}
